<div class="d-flex align-items-center">
  <i class="fas fa-spinner fa-pulse m-1"></i>

  @if (text) {
    <span
      class="text-medium">{{ text }}
    </span>
  }
</div>
